import React from 'react'

const OrderClock = ({ color = '#4E60FF' }: { color?: string }) => {
  return (
    <svg
      width='121'
      height='120'
      viewBox='0 0 121 120'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M60.5 110C32.9 110 10.5 87.6 10.5 60C10.5 32.4 32.9 10 60.5 10C88.1 10 110.5 32.4 110.5 60C110.5 87.6 88.1 110 60.5 110Z'
        fill={color}
        fillOpacity='0.08'
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M79.05 75.9001L63.55 66.6501C60.85 65.05 58.65 61.2 58.65 58.05V37.55'
        stroke={color}
        strokeWidth='4'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default OrderClock
